import styled from 'styled-components';

export const DataFeedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  min-height: 0;
  padding: 10px 14px 14px;
  justify-content: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const DataFeedTitle = styled.p`
  flex-grow: 1;
`;

export const ReachabilityCaption = styled.span`
  font-family: 'SFMono-Regular', Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New',
    monospace;
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  opacity: 0.56;
  padding: 2px 0 0;
`;

export const ReachabilitySlot = styled.div`
  width: 100%;
  height: 80px;
  min-height: 80px;
  max-height: 80px;
  max-width: none;
  margin-bottom: 12px;
  overflow: hidden;
`;

export const RawFeedPanel = styled.section`
  flex: 1 1 auto;
  min-height: 120px;
  width: 100%;
  max-width: none;
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.text};
  border-radius: 8px;
  background: ${({ theme }) => theme.text};
  color: ${({ theme }) => theme.background};
  box-shadow: inset 0 0 0 1px
    ${({ theme }) => (theme.name === 'short' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.1)')};
  overflow: hidden;
`;

export const RawFeedHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  border-bottom: 1px solid
    ${({ theme }) => (theme.name === 'short' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)')};
  background: ${({ theme }) =>
    theme.name === 'short' ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.08)'};
`;

export const RawFeedLabel = styled.span`
  font-family: 'SFMono-Regular', Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New',
    monospace;
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  opacity: 0.9;
`;

export const RawFeedState = styled.span`
  font-family: 'SFMono-Regular', Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New',
    monospace;
  font-size: 10px;
  letter-spacing: 0.04em;
  opacity: 0.6;
`;

export const DataFeedPrettify = styled.pre`
  white-space: pre;
  display: block;
  flex: 1 1 auto;
  min-height: 0;
  margin: 0;
  padding: 10px 12px 14px;
  font-family: 'SFMono-Regular', Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New',
    monospace;
  font-size: 11px;
  line-height: 1.45;
  letter-spacing: 0.01em;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => (theme.name === 'short' ? '#121212' : '#f3f6ff')};
  opacity: 0.98;
  text-rendering: geometricPrecision;
  overflow-y: auto;
  overflow-x: auto;

  .token-key {
    color: ${({ theme }) => (theme.name === 'short' ? '#004a87' : '#8dd3ff')};
  }

  .token-string {
    color: ${({ theme }) => (theme.name === 'short' ? '#0c6b58' : '#9df2c6')};
  }

  .token-number {
    color: ${({ theme }) => (theme.name === 'short' ? '#9a4d00' : '#ffd88f')};
  }

  .token-literal {
    color: ${({ theme }) => (theme.name === 'short' ? '#b0223f' : '#ff9db1')};
  }

  .token-punctuation {
    color: ${({ theme }) => (theme.name === 'short' ? '#505050' : '#b4bcc9')};
  }
`;
